<template>
  <el-dialog :visible.sync="dialogVisible" custom-class="batch-writeoff-dialog" width="88%" top="4vh"
    :close-on-click-modal="false" append-to-body @closed="onDialogClosed">
    <div slot="title" class="bw-title-wrap">
      <span class="bw-title-text">批量核销发放</span>
      <el-radio-group v-model="writeOffTab" size="small" class="bw-mode-tabs">
        <!-- <el-radio-button label="sameAmount">同金额批量核销</el-radio-button> -->
        <el-radio-button label="singleCustomer">给单个客户发多张卡</el-radio-button>
      </el-radio-group>
    </div>

    <!-- 同金额批量核销 -->
    <div v-show="writeOffTab === 'sameAmount'" class="bw-pane">
      <div class="bw-toolbar-row">
        <div class="bw-match-bar">
          <span class="bw-label">选择匹配金额</span>
          <el-select v-model="matchAmountSelect" clearable placeholder="请选择金额..." style="width: 220px"
            @change="onMatchAmountChange">
            <el-option v-for="a in amountOptions" :key="a" :label="a" :value="a" />
          </el-select>
          <el-button type="text" icon="el-icon-refresh" title="刷新" @click="refreshMatchSide" />
        </div>
        <div class="bw-stat-cards">
          <div class="bw-stat bw-stat--ok">
            <span class="bw-stat-label">匹配成功</span>
            <span class="bw-stat-num">{{ matchSuccessCount }}</span>
          </div>
          <div class="bw-stat bw-stat--warn">
            <span class="bw-stat-label">缺卡数量</span>
            <span class="bw-stat-num">{{ missingCardCount }}</span>
          </div>
        </div>
      </div>

      <el-row :gutter="12" class="bw-triple-row">
        <el-col :span="8">
          <div class="bw-panel">
            <div class="bw-panel-head">
              空闲卡密（ {{ matchAmountLabel }} 元未使用）
            </div>
            <el-table :data="idleCardList" border size="small" max-height="280" empty-text="请先选择金额">
              <el-table-column prop="account" label="卡密账号" min-width="96" show-overflow-tooltip />
              <el-table-column prop="password" label="密码" width="88" show-overflow-tooltip />
              <el-table-column prop="validUntil" label="有效期至" width="102" />
            </el-table>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="bw-panel">
            <div class="bw-panel-head">待匹配客户（ 需 {{ matchAmountLabel }} 元 ）</div>
            <el-table :data="pendingCustomerList" border size="small" max-height="280" empty-text="请先选择金额">
              <el-table-column prop="name" label="姓名" width="72" />
              <el-table-column prop="phone" label="手机号" min-width="108" />
              <el-table-column prop="demand" label="需求" width="88" />
            </el-table>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="bw-panel">
            <div class="bw-panel-head bw-panel-head--split">
              <span>配对结果预览</span>
              <el-button type="primary" size="mini" plain icon="el-icon-magic-stick" @click="autoOneClickPair">
                自动一键配对
              </el-button>
            </div>
            <el-table :data="previewPairList" border size="small" max-height="280" empty-text="暂无匹配数据">
              <el-table-column type="index" label="#" width="44" />
              <el-table-column prop="customerName" label="客户" min-width="72" show-overflow-tooltip />
              <el-table-column prop="phone" label="手机" width="102" show-overflow-tooltip />
              <el-table-column prop="cardAccount" label="匹配卡密" min-width="96" show-overflow-tooltip />
              <el-table-column label="操作" width="72" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="removePreviewRow(scope.$index)">移除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 给单个客户发多张卡 -->
    <div v-show="writeOffTab === 'singleCustomer'" class="bw-pane bw-pane--single">
      <div class="bw-section">
        <div class="bw-section-title">1. 选择目标客户</div>
        <div class="bw-single-row">
          <el-select v-model="singleCustomerId" filterable clearable :loading="loadingCustomers" placeholder="点击选择客户..."
            class="bw-customer-select" @change="onSingleCustomerChange">
            <el-option v-for="c in customerOptions" :key="c.id" :label="c.label" :value="c.id" />
          </el-select>
          <span class="bw-required-amt">
            所需金额: <strong>{{ formatYuan(singleRequiredAmount) }}</strong>
          </span>
          <el-button type="text" icon="el-icon-refresh" size="mini" @click="fetchCustomers">刷新</el-button>
        </div>

        <div v-if="loadingDetail" class="bw-loading-tip">
          <i class="el-icon-loading" /> 正在加载客户详情...
        </div>


      </div>

      <div class="bw-section">
        <div class="bw-section-title bw-section-title--row">
          <span>2. 智能卡密搭配方案</span>
          <el-button v-if="!customerInfo || customerInfo.bindingCard === 0" type="text" icon="el-icon-refresh"
            size="small" :disabled="!customerDetail || loadingCards" :loading="loadingCards"
            @click="refreshMatch">重新匹配</el-button>
        </div>
        <template v-if="customerInfo && customerInfo.bindingCard > 0">
          <div class="bw-bound-warning" style="margin-bottom:10px">
            <i class="el-icon-warning-outline" />
            该客户已有绑定卡密，不可再添加新卡密
          </div>
          <el-table :data="availableCards" border size="small" max-height="240">
            <el-table-column prop="cardNum" label="卡密账号" show-overflow-tooltip />
            <el-table-column prop="cardPsw" label="密码" show-overflow-tooltip />
            <el-table-column prop="amountLabel" label="金额" />
          </el-table>
        </template>
        <template v-else>
          <div v-if="!singleCustomerId || !customerDetail" class="bw-empty-hint" style="margin-bottom:10px">请选择客户以生成推荐方案
          </div>
          <el-alert :title="planAlertSummary" type="warning" :closable="false" show-icon class="bw-plan-alert" />
          <div v-if="loadingCards" class="bw-loading-tip" style="margin-top:10px"><i class="el-icon-loading" />
            正在匹配卡密...</div>
          <el-table v-else :data="planRows" border size="small" max-height="240" style="margin-top: 10px">
            <el-table-column prop="denomination" label="面值(元)" width="120" />
            <el-table-column prop="qty" label="数量" width="80" />
            <el-table-column prop="recommended" label="系统推荐卡密" min-width="180" show-overflow-tooltip />
          </el-table>
          <div v-if="customerDetail && !loadingCards && !planRows.length" class="bw-empty-hint">暂无匹配的可用卡密</div>
          <div v-if="customerDetail && !loadingCards && planRows.length && planDiff > 0" class="bw-bound-warning"
            style="margin-top:10px">
            <i class="el-icon-warning-outline" /> 系统现有卡密无法满足匹配，请先新增卡密后再重新匹配
          </div>
        </template>
      </div>

      <div class="bw-section">
        <div class="bw-section-title bw-section-title--row">
          <span>3. 短信通知预览</span>
        </div>

        <div class="bw-sms-row">
          <span class="bw-sms-label">选择模板:</span>
          <el-select v-model="selectedTemplate" style="width: 320px" size="small" :loading="loadingTemplates"
            placeholder="请选择短信模板">
            <el-option v-for="t in smsTemplates" :key="t.id" :label="t.name" :value="t.id" />
          </el-select>
        </div>
        <el-input v-model="smsPreviewText" readonly type="textarea" :rows="5" placeholder="选择模板后自动生成预览..." />
      </div>
    </div>

    <template slot="footer">
      <div v-if="writeOffTab === 'sameAmount'" class="bw-footer bw-footer--same">
        <div class="bw-tip">
          <i class="el-icon-info" />
          确认核销后，卡密状态将变更为「已使用」，并同步发送短信。
        </div>
        <div class="bw-footer-actions">
          <el-button @click="previewAllSms">预览全部短信</el-button>
          <el-button type="success" icon="el-icon-position" @click="submitBatchMassSend">
            批量核销并群发
          </el-button>
        </div>
      </div>
      <div v-else class="bw-footer bw-footer--single">
        <el-button @click="resetSingleMode" :disabled="submitting">重置选择</el-button>
        <el-button class="btn-black" type="primary" icon="el-icon-check" :loading="submitting"
          @click="confirmSingleIssue">
          确认发放并核销
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { getCustomerList } from '@/api/customer'
import { getOwnerDetail } from '@/api/customer'
import { getCardList, redeemByOneOwner } from '@/api/card'
import { getSmsTemplateList } from '@/api/sms'

function parseYuanFromDisplay(s) {
  if (!s) return 0
  const n = parseFloat(String(s).replace(/[¥,\s]/g, ''))
  return Number.isNaN(n) ? 0 : n
}

function formatYuanNum(n) {
  const x = Number(n) || 0
  return `¥${x.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

export default {
  name: 'BatchWriteOffDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    cardTableData: {
      type: Array,
      default: () => []
    },
    initialTab: {
      type: String,
      default: 'sameAmount'
    }
  },
  data() {
    return {
      writeOffTab: 'sameAmount',
      matchAmountSelect: null,
      matchSuccessCount: 0,
      missingCardCount: 0,
      idleCardList: [],
      pendingCustomerList: [],
      previewPairList: [],
      // 单个客户核销 - 数据
      singleCustomerId: '',
      singleRequiredAmount: 0,
      planRows: [],
      smsPreviewText: '',
      submitting: false,
      // 客户列表
      customerOptions: [],
      customerList: [],
      loadingCustomers: false,
      // 客户详情
      customerDetail: null,
      loadingDetail: false,
      // 可用卡密
      availableCards: [],
      loadingCards: false,
      // 短信模板
      smsTemplates: [],
      selectedTemplate: '',
      loadingTemplates: false,
      // 原始卡密数据
      rawCardDataMap: {}
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(v) {
        this.$emit('update:visible', v)
      }
    },
    amountOptions() {
      const seen = new Set()
      const list = []
      this.cardTableData.forEach((row) => {
        if (row.status !== 'unused') return
        const a = row.amount
        if (!seen.has(a)) {
          seen.add(a)
          list.push(a)
        }
      })
      return list
    },
    matchAmountLabel() {
      if (!this.matchAmountSelect) return '0'
      return String(parseYuanFromDisplay(this.matchAmountSelect))
    },
    planCurrentTotal() {
      return this.planRows.reduce((sum, r) => sum + (Number(r.denomination) || 0) * (Number(r.qty) || 0), 0)
    },
    planDiff() {
      return (Number(this.singleRequiredAmount) || 0) - this.planCurrentTotal
    },
    customerInfo() {
      if (this.customerDetail) {
        return {
          name: this.customerDetail.ownerName || '',
          phone: this.customerDetail.ownerPhone || '',
          rechargeMoney: this.customerDetail.rechargeMoney || 0,
          bindingCard: this.customerDetail.bindingCard || 0,
          ownerId: this.customerDetail.ownerId || this.singleCustomerId
        }
      }
      return null
    },
    planAlertSummary() {
      return `客户所需: ${formatYuanNum(this.singleRequiredAmount)}　当前搭配: ${formatYuanNum(
        this.planCurrentTotal
      )}　差额: ${formatYuanNum(this.planDiff)}`
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.writeOffTab = this.initialTab
        this.resetSameAmountPane()
        this.resetSinglePaneSoft()
        this.fillSmsPreview()
        this.fetchCustomers()
        this.fetchTemplates()
      }
    },
    initialTab(v) {
      if (this.visible) this.writeOffTab = v
    },
    selectedTemplate() {
      this.fillSmsPreview()
    }
  },
  methods: {
    formatYuan: formatYuanNum,
    onDialogClosed() {
      this.$emit('closed')
    },
    resetSameAmountPane() {
      this.matchAmountSelect = null
      this.matchSuccessCount = 0
      this.missingCardCount = 0
      this.idleCardList = []
      this.pendingCustomerList = []
      this.previewPairList = []
    },
    resetSinglePaneSoft() {
      this.singleCustomerId = ''
      this.singleRequiredAmount = 0
      this.planRows = []
      this.smsPreviewText = ''
      this.customerDetail = null
      this.availableCards = []
      this.selectedTemplate = ''
    },
    onMatchAmountChange() {
      this.previewPairList = []
      this.matchSuccessCount = 0
      this.missingCardCount = 0
      this.syncIdleAndPending()
    },
    syncIdleAndPending() {
      const amt = this.matchAmountSelect
      if (!amt) {
        this.idleCardList = []
        this.pendingCustomerList = []
        return
      }
      this.idleCardList = this.cardTableData
        .filter((r) => r.status === 'unused' && r.amount === amt)
        .map((r) => ({
          account: r.account,
          password: r.password,
          validUntil: '2027-12-31'
        }))
      this.pendingCustomerList = []
    },
    refreshMatchSide() {
      this.syncIdleAndPending()
      this.$message.success('已刷新')
    },
    autoOneClickPair() {
      if (!this.matchAmountSelect) {
        this.$message.warning('请先选择匹配金额')
        return
      }
      this.syncIdleAndPending()
      const cards = this.idleCardList
      const custs = this.pendingCustomerList
      const n = Math.min(cards.length, custs.length)
      this.matchSuccessCount = n
      this.missingCardCount = Math.max(0, custs.length - cards.length)
      this.previewPairList = []
      for (let i = 0; i < n; i++) {
        this.previewPairList.push({
          customerName: custs[i].name,
          phone: custs[i].phone,
          cardAccount: cards[i].account
        })
      }
      if (!custs.length && !cards.length) {
        this.$message.info('当前金额下暂无空闲卡密或待匹配客户')
      } else if (n === 0) {
        this.$message.warning('无法配对：客户与卡密数量不匹配')
      } else {
        this.$message.success(`已生成 ${n} 条配对预览`)
      }
    },
    removePreviewRow(index) {
      this.previewPairList.splice(index, 1)
      this.matchSuccessCount = this.previewPairList.length
    },
    previewAllSms() {
      const sample =
        '【AdminOS】您申请的卡密已核销发放，卡号：KM-2026-XXXX，请查收短信并及时使用。'
      this.$alert(sample, '预览全部短信', {
        confirmButtonText: '知道了'
      })
    },
    submitBatchMassSend() {
      if (!this.previewPairList.length) {
        this.$message.warning('请先完成配对或点击自动一键配对')
        return
      }
      this.$confirm(`将对 ${this.previewPairList.length} 条记录批量核销并发送短信，是否继续？`, '提示', {
        type: 'warning'
      })
        .then(() => {
          this.$emit('success', { mode: 'sameAmount', pairs: this.previewPairList })
          this.dialogVisible = false
          this.$message.success('批量核销并群发已提交')
        })
        .catch(() => { })
    },
    async fetchCustomers() {
      this.loadingCustomers = true
      try {
        const res = await getCustomerList({
          redeemStatus: '4',
          pageNum: 1,
          pageSize: 999,
          ownerStatus: '1',
        })
        const rows = res.rows || res.data || []
        this.customerList = rows
        this.customerOptions = rows.map((c) => ({
          id: c.ownerId || c.id,
          label: `${c.ownerName || ''} ${c.ownerPhone || ''}`,
          needAmount: c.rechargeMoney || 0
        }))
      } catch {
        // 错误已在 request.js 中处理
      } finally {
        this.loadingCustomers = false
      }
    },
    async fetchCustomerDetail() {
      if (!this.singleCustomerId) return
      this.loadingDetail = true
      try {
        const res = await getOwnerDetail(this.singleCustomerId)
        const data = res.data || res
        this.customerDetail = data
        this.singleRequiredAmount = (Number(data.rechargeMoney) || 0) - (Number(data.redeemSuccessMoney) || 0)

        if (data.bindingCard > 0) {
          const boundList = data.cardList || []
          console.log('boundList', boundList, data)
          this.rawCardDataMap = {}
          this.availableCards = boundList.map((item) => {
            const id = item.cardId || item.id
            this.rawCardDataMap[id] = item
            return {
              id,
              cardNum: item.cardNum || '',
              cardPsw: item.cardPsw || item.cardPwd || '',
              account: item.cardNum || '',
              password: item.cardPsw || item.cardPwd || '',
              amount: item.cardMoney,
              amountLabel: `¥${Number(item.cardMoney).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            }
          })
          this.planRows = []
        } else {
          // 未绑定卡片：拉取可用卡密并智能匹配
          await this.fetchCards()
        }
      } catch {
        await this.fetchCards()
      } finally {
        this.loadingDetail = false
      }
    },
    async fetchCards() {
      this.loadingCards = true
      try {
        const result = await getCardList({ pageSize: 999, pageNum: 1, bindingUser: 0 })
        const rows = result.data || result.rows || []
        this.rawCardDataMap = {}
        this.availableCards = rows.map((item) => {
          const id = item.id || item.cardId
          this.rawCardDataMap[id] = item
          return {
            id,
            cardNum: item.cardNum || '',
            cardPsw: item.cardPsw || item.cardPwd || '',
            account: item.cardNum || '',
            password: item.cardPsw || item.cardPwd || '',
            amount: item.cardMoney,
            amountLabel: item.cardMoney != null
              ? `¥${Number(item.cardMoney).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
              : ''
          }
        })
        this.generateRecommendedPlan()
      } catch {
        this.availableCards = []
      } finally {
        this.loadingCards = false
      }
    },
    async fetchTemplates() {
      this.loadingTemplates = true
      try {
        const result = await getSmsTemplateList({ reviewStatus: 0, pageSize: 999, pageNum: 1, })
        const rows = result.data || result.rows || []
        this.smsTemplates = rows.map((item) => ({
          id: item.templateId,
          name: item.templateName || '',
          content: item.templateContent || ''
        }))
      } catch {
        this.smsTemplates = []
      } finally {
        this.loadingTemplates = false
      }
    },
    async onSingleCustomerChange(id) {
      this.planRows = []
      this.customerDetail = null
      this.availableCards = []
      this.singleRequiredAmount = 0
      if (!id) {
        this.fillSmsPreview()
        return
      }
      await this.fetchCustomerDetail()
      this.fillSmsPreview()
    },
    generateRecommendedPlan() {
      const need = Math.round(Number(this.singleRequiredAmount))
      if (!need || !this.availableCards.length) {
        this.planRows = []
        return
      }
      // 按金额从大到小排序，优先用大面值减少卡密张数
      const sortedCards = [...this.availableCards].sort((a, b) => Number(b.amount) - Number(a.amount))
      const rows = []
      let remain = need
      for (const card of sortedCards) {
        if (remain <= 0) break
        const d = Math.round(Number(card.amount))
        if (d <= 0 || d > remain) continue
        rows.push({
          denomination: d,
          qty: 1,
          recommended: `${card.account} / ${card.password}`
        })
        remain -= d
      }
      this.planRows = rows
    },
    async refreshMatch() {
      if (!this.singleCustomerId || !this.customerDetail) return
      await this.fetchCards()
      this.$message.success('已重新匹配')
    },
    fillSmsPreview() {
      if (!this.selectedTemplate || !this.singleCustomerId) {
        this.smsPreviewText = ''
        return
      }
      const template = this.smsTemplates.find((t) => t.id === this.selectedTemplate)
      this.smsPreviewText = template ? template.content : ''
    },
    resetSingleMode() {
      this.resetSinglePaneSoft()
      this.customerDetail = null
      this.availableCards = []
      this.fetchCustomers()
      this.$message.info('已重置')
    },
    async confirmSingleIssue() {
      if (!this.singleCustomerId) {
        this.$message.error('请先选择目标客户')
        return
      }
      if (!this.customerDetail) {
        this.$message.error('客户详情加载中，请稍后')
        return
      }
      if (!this.selectedTemplate) {
        this.$message.error('请选择短信模板')
        return
      }

      // 已绑定卡密的客户：直接使用可用卡密列表
      const isBound = this.customerInfo && this.customerInfo.bindingCard > 0
      if (!isBound) {
        if (!this.planRows.length) {
          this.$message.error('请完善搭配方案')
          return
        }
        const diff = (Number(this.singleRequiredAmount) || 0) - this.planRows.reduce((sum, r) => sum + (Number(r.denomination) || 0), 0)
        if (Math.abs(diff) > 0.01) {
          this.$message.error('当前搭配金额与客户所需不一致，请检查差额')
          return
        }
      }

      this.submitting = true
      try {
        // 构建卡密 ID 列表
        let cardIdList = []
        if (isBound) {
          cardIdList = this.availableCards.map((c) => c.id)
        } else {
          for (const row of this.planRows) {
            if (row.recommended && row.recommended !== '待匹配' && !row.recommended.startsWith('零头')) {
              const parts = row.recommended.split(' / ')
              const cardNum = parts[0].trim()
              const found = Object.values(this.rawCardDataMap).find(
                (c) => (c.cardNum || c.account) === cardNum
              )
              if (found) cardIdList.push(found.id || found.cardId)
            }
          }
        }

        let res = await redeemByOneOwner({
          cardIdList,
          ownerId: this.singleCustomerId,
          templateId: this.selectedTemplate
        })
        if (res.code === 200) {
          if (res.data.hxSuccessFlag === '1') {
            if (res.data.messageFlag === '1') {
              this.$message.success('核销成功，短信发送成功！')

            } else {
              this.$message.error('核销成功，短信发送失败，请到客户管理中重新发送短信！')

            }
            this.resetSinglePaneSoft()
            this.customerDetail = null
            this.availableCards = []
            this.fetchCustomers()

          } else {
            // 批量失败 - 重新拉取客户详情和卡密列表
            this.$message.error(res.data.failReason)
            await this.fetchCustomerDetail()
          }
        }

      } catch {
        // 错误已在 request.js 中处理
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.bw-title-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  padding-right: 36px;
}

.bw-title-text {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.bw-mode-tabs {
  vertical-align: middle;
}

.bw-pane {
  min-height: 420px;
}

.bw-toolbar-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}

.bw-match-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.bw-label {
  font-size: 13px;
  color: #606266;
  white-space: nowrap;
}

.bw-stat-cards {
  display: flex;
  gap: 12px;
}

.bw-stat {
  min-width: 120px;
  padding: 10px 14px;
  border-radius: 8px;
  text-align: center;
}

.bw-stat--ok {
  background: #f0f9eb;
  border: 1px solid #e1f3d8;
}

.bw-stat--warn {
  background: #fdf6ec;
  border: 1px solid #faecd8;
}

.bw-stat-label {
  display: block;
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
}

.bw-stat-num {
  font-size: 22px;
  font-weight: 600;
  color: #303133;
}

.bw-triple-row {
  margin-bottom: 16px;
}

.bw-panel {
  background: #fafafa;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 10px;
  height: 100%;
}

.bw-panel-head {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
}

.bw-panel-head--split {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.bw-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding-top: 8px;
  margin-top: 8px;
  border-top: 1px solid #ebeef5;
}

.bw-footer--same {
  border-top: none;
  margin-top: 0;
  padding-top: 0;
}

.bw-tip {
  flex: 1;
  min-width: 220px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}

.bw-tip i {
  color: #909399;
  margin-right: 6px;
}

.bw-footer-actions {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

.bw-pane--single .bw-section {
  margin-bottom: 22px;
}

.bw-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 12px;
}

.bw-section-title--row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.bw-single-row {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.bw-customer-select {
  flex: 1;
  min-width: 260px;
  max-width: 480px;
}

.bw-required-amt {
  font-size: 14px;
  color: #606266;
}

.bw-required-amt strong {
  color: #303133;
  font-size: 16px;
}

.bw-plan-alert {
  margin-bottom: 0;
}

.bw-empty-hint {
  text-align: center;
  color: #909399;
  font-size: 13px;
  padding: 16px;
  background: #fafafa;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  margin-top: 10px;
}

.bw-sms-hint {
  font-size: 12px;
  font-weight: normal;
  color: #909399;
}

.bw-sms-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.bw-sms-label {
  font-size: 13px;
  color: #606266;
}

.bw-footer--single {
  justify-content: flex-end;
  border-top: 1px solid #ebeef5;
  padding-top: 16px;
  margin-top: 8px;
}

.bw-cell-num {
  width: 100%;
}

.bw-qty-fixed {
  display: inline-block;
  width: 100%;
  text-align: center;
  color: #606266;
  font-size: 13px;
}

.text-danger-action {
  color: #f56c6c !important;
}

.bw-customer-info {
  margin-top: 10px;
  padding: 10px 14px;
  background: #f0f9eb;
  border: 1px solid #e1f3d8;
  border-radius: 6px;
  font-size: 13px;
  color: #303133;
}

.bw-loading-tip {
  margin-top: 10px;
  padding: 10px;
  text-align: center;
  color: #909399;
  font-size: 13px;
}

.bw-bound-warning {
  margin-top: 10px;
  padding: 10px 14px;
  background: #fef0f0;
  border: 1px solid #fde2e2;
  border-radius: 6px;
  font-size: 13px;
  color: #f56c6c;
  text-align: center;
}

.bw-bound-warning i {
  margin-right: 6px;
}
</style>

<style>
.batch-writeoff-dialog .el-dialog__body {
  padding: 12px 20px 20px;
}

.batch-writeoff-dialog .el-dialog__header {
  padding: 16px 20px 8px;
}

.batch-writeoff-dialog .el-dialog__footer {
  padding: 0 20px 16px;
}

.batch-writeoff-dialog .el-table__fixed-right {
  background: #fff;
  border-left: 1px solid #ebeef5;
}

.batch-writeoff-dialog .el-table__fixed-right td,
.batch-writeoff-dialog .el-table__fixed-right th {
  background: #fff;
}

.batch-writeoff-dialog .el-table__body-wrapper .el-table__fixed-right .el-table__body {
  border-left: 1px solid #ebeef5;
}
</style>
